import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'
import { useInboxesStore } from './stores/inboxes'
import './style.css'

async function bootstrap() {
  const app = createApp(App)
  app.use(createPinia())

  // Hidrata stores ANTES do router (guards enxergam sessão persistida).
  const auth = useAuthStore()
  auth.hydrate()
  useInboxesStore().hydrate()

  // Logout automático em 401 (token expirado/revogado). Disparado pelo
  // interceptor em api/chatwoot.ts.
  window.addEventListener('chatwoot:unauthorized', () => {
    auth.logout()
    if (router.currentRoute.value.name !== 'login') {
      router.push({
        name: 'login',
        query: { redirect: router.currentRoute.value.fullPath },
      })
    }
  })

  // SSO: se ainda não está autenticado (sem sessionStorage), tenta usar o
  // cookie `kanban_atom_token` emitido pelo chatwoot-injector quando o
  // agente está logado em chat.pablomendes.atomai.digital. Falha silenciosa
  // → cai para o login form normal.
  if (!auth.isAuthenticated) {
    await auth.trySSO()
  }

  app.use(router)
  app.mount('#app')
}

void bootstrap()
